import { FC } from 'react'

export const CitationIcon: FC<{ width: string }> = ({ width }) => {
  return (
    <svg width={width} height="20" fill="none">
      <path
        d="M14.8 19.81H5.2c-1.44 0-2.61-1.17-2.61-2.61V2.8C2.59 1.36 3.76.19 5.2.19h9.6c1.44 0 2.61 1.17 2.61 2.61v14.4c0 1.44-1.17 2.61-2.61 2.61Zm-9.6-18c-.54 0-.99.44-.99.99v14.4c0 .54.44.99.99.99h9.6c.54 0 .99-.44.99-.99V2.8c0-.54-.44-.99-.99-.99H5.2Z"
        fill="#302C41"
      />
      <path
        d="M13.6 8.89H5.8c-.38 0-.69-.31-.69-.69 0-.38.31-.69.69-.69h7.8c.38 0 .69.31.69.69 0 .38-.31.69-.69.69ZM12.4 11.29H5.8c-.38 0-.69-.31-.69-.69 0-.38.31-.69.69-.69h6.6c.38 0 .69.31.69.69 0 .38-.31.69-.69.69ZM6.4 6.1a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z"
        fill="#302C41"
      />
      <path
        d="M6.4 6.79c-.71 0-1.29-.58-1.29-1.29 0-.71.58-1.29 1.29-1.29.71 0 1.29.58 1.29 1.29 0 .71-.58 1.29-1.29 1.29Zm0-1.38s-.09.04-.09.09c0 .1.17.1.17 0a.09.09 0 0 0-.09-.09h.01ZM13.6 14.8a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z"
        fill="#302C41"
      />
      <path
        d="M13.6 15.49c-.71 0-1.29-.58-1.29-1.29 0-.71.58-1.29 1.29-1.29.71 0 1.29.58 1.29 1.29 0 .71-.58 1.29-1.29 1.29Zm0-1.38s-.09.04-.09.09c0 .1.17.09.17 0a.09.09 0 0 0-.09-.09h.01ZM9.4 6.1a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z"
        fill="#302C41"
      />
      <path
        d="M9.4 6.79c-.71 0-1.29-.58-1.29-1.29 0-.71.58-1.29 1.29-1.29.71 0 1.29.58 1.29 1.29 0 .71-.58 1.29-1.29 1.29Zm0-1.38s-.09.04-.09.09c0 .1.17.1.17 0a.09.09 0 0 0-.09-.09h.01ZM10.6 14.8a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z"
        fill="#302C41"
      />
      <path
        d="M10.6 15.49c-.71 0-1.29-.58-1.29-1.29 0-.71.58-1.29 1.29-1.29.71 0 1.29.58 1.29 1.29 0 .71-.58 1.29-1.29 1.29Zm0-1.38s-.09.04-.09.09c0 .1.17.09.17 0a.09.09 0 0 0-.09-.09h.01ZM5.8 6.19c-.38 0-.69-.31-.69-.69V4.3c0-.88.71-1.59 1.59-1.59H7c.38 0 .69.31.69.69 0 .38-.31.69-.69.69h-.3c-.12 0-.21.09-.21.21v1.2c0 .38-.31.69-.69.69ZM13.3 17.11H13c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h.3s.09-.04.09-.09v-1.2c0-.45.36-.81.81-.81.45 0 .81.36.81.81v1.2c0 .94-.77 1.71-1.71 1.71ZM8.8 6.19c-.38 0-.69-.31-.69-.69V4.3c0-.88.71-1.59 1.59-1.59h.3c.38 0 .69.31.69.69 0 .38-.31.69-.69.69h-.3c-.12 0-.21.09-.21.21v1.2c0 .38-.31.69-.69.69Z"
        fill="#302C41"
      />
      <path
        d="M10.3 16.99H10c-.38 0-.69-.31-.69-.69 0-.38.31-.69.69-.69h.3c.12 0 .21-.09.21-.21v-1.2c0-.38.31-.69.69-.69.38 0 .69.31.69.69v1.2c0 .88-.71 1.59-1.59 1.59Z"
        fill="#302C41"
      />
    </svg>
  )
}
